"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tableList = _interopRequireDefault(require("./tableList"));

var _tableAccordion = _interopRequireDefault(require("./tableAccordion"));

var _loader = _interopRequireDefault(require("../loader/loader"));

var _formInline = _interopRequireDefault(require("../formInline/formInline"));

var _pager = _interopRequireDefault(require("../pager/pager"));

var _selectableActionsForm = _interopRequireDefault(require("./selectableActionsForm"));

var _constants = require("../../../utils/constants");

var _reactI18next = require("react-i18next");

var _resourceKeys = require("../providers/translations/resources/resourceKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var viewPortBreakPoint = 768;

var Table = function Table(props) {
  var id = props.id,
      columns = props.columns,
      data = props.data,
      loading = props.loading,
      selectable = props.selectable,
      striped = props.striped,
      responsive = props.responsive,
      selectActions = props.selectActions,
      actionResultLoading = props.actionResultLoading,
      page = props.page,
      pageSize = props.pageSize,
      goAtPrevious = props.goAtPrevious,
      goAtNext = props.goAtNext,
      goAtEnd = props.goAtEnd,
      goAtStart = props.goAtStart,
      goAtPage = props.goAtPage,
      totalPages = props.totalPages,
      onDatumSelect = props.onDatumSelect,
      selected = props.selected,
      onSelectAll = props.onSelectAll,
      pageSizeOptions = props.pageSizeOptions,
      onPageSizeChange = props.onPageSizeChange,
      onSelectAction = props.onSelectAction,
      selectedAction = props.selectedAction,
      onSelectedActionApply = props.onSelectedActionApply,
      totalRecords = props.totalRecords,
      orderBy = props.orderBy,
      orderAsc = props.orderAsc,
      onSortedChange = props.onSortedChange,
      accordionItemHeaderFormatter = props.accordionItemHeaderFormatter,
      renderAsTableAccordion = props.renderAsTableAccordion,
      expandableRow = props.expandableRow,
      hasActions = props.hasActions,
      nestedTableTitle = props.nestedTableTitle,
      tableHover = props.tableHover,
      customNestedTableComponent = props.customNestedTableComponent,
      onRowStyleChange = props.onRowStyleChange,
      noResultsMessage = props.noResultsMessage,
      loadingTableList = props.loadingTableList,
      onExpandRow = props.onExpandRow,
      omitSelectActionForm = props.omitSelectActionForm,
      alwaysDisplaySelectableActionsForm = props.alwaysDisplaySelectableActionsForm,
      selectableRowDisabled = props.selectableRowDisabled,
      hideHorizontalRuleOfActions = props.hideHorizontalRuleOfActions,
      isIndented = props.isIndented,
      headerVariant = props.headerVariant,
      previousPageTestId = props.previousPageTestId,
      firstPageTestId = props.firstPageTestId,
      lastPageTestId = props.lastPageTestId,
      nextPageTestId = props.nextPageTestId,
      paginationWrapperTestId = props.paginationWrapperTestId,
      paginationRecordsShownTestId = props.paginationRecordsShownTestId,
      viewControlTestId = props.viewControlTestId,
      _props$selectedRowSty = props.selectedRowStyle,
      selectedRowStyle = _props$selectedRowSty === void 0 ? _constants.primaryVariantStyle : _props$selectedRowSty; //for accordion

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var onExpand = function onExpand(datumIndex) {
    if (expanded.includes(datumIndex)) {
      setExpanded(expanded.filter(function (item) {
        return item !== datumIndex;
      }));
    } else {
      setExpanded([].concat(_toConsumableArray(expanded), [datumIndex]));
    }
  }; //for nested table lists


  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      expandedTableRows = _useState4[0],
      setExpandedTableRows = _useState4[1];

  var onTableRowExpand = function onTableRowExpand(datumIndex, selectedRow) {
    if (expandedTableRows.includes(datumIndex)) {
      setExpandedTableRows(expandedTableRows.filter(function (item) {
        return item !== datumIndex;
      }));
    } else {
      setExpandedTableRows([].concat(_toConsumableArray(expandedTableRows), [datumIndex]));
    }

    if (onExpandRow) {
      onExpandRow(selectedRow, datumIndex);
    }
  };

  var totalColumns = columns.filter(function (x) {
    return x.hidden !== true;
  }).length + (expandableRow ? 1 : 0) + (hasActions ? 1 : 0) + (selectable ? 1 : 0); //plus one for the column with the expand btn

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return _react.default.createElement("div", {
    id: id ? id : null
  }, page && _react.default.createElement(_formInline.default, {
    id: id ? "".concat(id, "_table_select_items") : null,
    variant: "select",
    label: t(_resourceKeys.resourceKeys.view.key),
    viewControlTestId: viewControlTestId,
    inputProps: {
      options: pageSizeOptions,
      value: pageSize,
      name: "pageSize",
      onChange: onPageSizeChange
    }
  }), (selectable && selectActions && !omitSelectActionForm || alwaysDisplaySelectableActionsForm) && _react.default.createElement(_selectableActionsForm.default, props), loading && _react.default.createElement(_loader.default, {
    id: id ? "".concat(id, "_table_loader") : null,
    variant: "list"
  }), !loading && _react.default.createElement(_react.default.Fragment, null, renderAsTableAccordion ? _react.default.createElement(_tableAccordion.default, _extends({
    id: id ? "".concat(id, "_table_accordion") : null
  }, props, {
    expandedTableRows: expandedTableRows,
    onTableRowExpand: onTableRowExpand,
    onExpand: onExpand,
    expanded: expanded,
    totalColumns: totalColumns
  })) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactResponsive.default, {
    minDeviceWidth: viewPortBreakPoint
  }, _react.default.createElement(_tableList.default, _extends({
    expandedTableRows: expandedTableRows,
    onTableRowExpand: onTableRowExpand
  }, props, {
    totalColumns: totalColumns
  }))), _react.default.createElement(_reactResponsive.default, {
    maxDeviceWidth: viewPortBreakPoint - 1
  }, _react.default.createElement(_tableAccordion.default, _extends({
    expandedTableRows: expandedTableRows,
    onTableRowExpand: onTableRowExpand
  }, props, {
    onExpand: onExpand,
    expanded: expanded,
    totalColumns: totalColumns
  })))), page && _react.default.createElement(_pager.default, {
    pageSize: pageSize,
    totalItems: totalRecords,
    totalPages: totalPages,
    page: page,
    goAtPrevious: goAtPrevious,
    goAtNext: goAtNext,
    goAtStart: goAtStart,
    goAtEnd: goAtEnd,
    goAtPage: goAtPage,
    previousPageTestId: previousPageTestId,
    firstPageTestId: firstPageTestId,
    lastPageTestId: lastPageTestId,
    nextPageTestId: nextPageTestId,
    paginationWrapperTestId: paginationWrapperTestId,
    paginationRecordsShownTestId: paginationRecordsShownTestId
  })));
};

Table.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array that contains the rows indexes that should have a loader */
  loadingRows: _propTypes.default.arrayOf(_propTypes.default.number),

  /** boolean indicating that the table should have a vertical aligned header */
  withVerticalAlignedHeader: _propTypes.default.bool,

  /** boolean indicating that when the table has actions they should appear on the left of the table */
  actionOnLeft: _propTypes.default.bool,

  /** Boolean prop that when is set to true an extra column will be displayed to display the actions - links.
   * If set to true the property actions must be specified */
  hasActions: _propTypes.default.bool,

  /** The columns of the list - table. The propertyName is used to match the desired property of the data objects.
   * eg: the data object {email : "user@test.io"} will be matched by the column: {propertyName: "email", header:
   * "Email!"}. If you wish to access nested properties from the data you should specify them again in the
   * propertyName separated with a dot "." eg: data: {user: {email : "user@test.io"}}, then the property name will be
   * propertyName: "user.email". The id property of is used for sorting. So it must match the correct sortBy key.
   * The formatter is a callback used to format the data as you wish. It is invoked with the datum. For example
   * formatting timestamp dates. the sortable prop specifies if the column is sortable
   * . The style property can be used to style the th as you want. The sorting style property can be used to
   * style the sorting arrows of the th as you want.*/
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    propertyName: _propTypes.default.string.isRequired,
    header: _propTypes.default.string.isRequired,
    id: _propTypes.default.string,
    formatter: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    style: _propTypes.default.object,
    sortingStyle: _propTypes.default.object,
    numberFormat: _propTypes.default.bool,
    hidden: _propTypes.default.bool
  })).isRequired,

  /** The data that should be displayed. Can by an array of objects of any type and shape */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** Boolean indicating that the table should be rendered only in accordion format */
  renderAsTableAccordion: _propTypes.default.bool,

  /** Boolean indicating that the table is loading the data */
  loading: _propTypes.default.bool,

  /** Boolean indicating that the items are selectable. If set to true, the props selected, onDatumSelect,
   * onSelectAll MUST be specified */
  selectable: _propTypes.default.bool,

  /** Object containing the selected items */
  selected: _propTypes.default.object,

  /** Boolean indicating if the rows should be striped */
  striped: _propTypes.default.bool,

  /** Boolean indicating if the table should be responsive */
  responsive: _propTypes.default.bool,

  /** Array of options like the SelectInput component*/
  selectActions: _propTypes.default.array,

  /** Boolean indicating the the action execution is loading*/
  actionResultLoading: _propTypes.default.bool,

  /** The current page of the pager */
  page: _propTypes.default.number,

  /** Number the specifies the size of each page */
  pageSize: _propTypes.default.number,

  /** Callback invoked when go at previous button is clicked */
  goAtPrevious: _propTypes.default.func,

  /** Callback invoked when  the the go at next button is clicked*/
  goAtNext: _propTypes.default.func,

  /** Callback invoked when the go at start button is clicked */
  goAtStart: _propTypes.default.func,

  /** Callback invoked when the go at end button is clicked */
  goAtPage: _propTypes.default.func,

  /** The total pager  items*/
  totalPages: _propTypes.default.number,

  /** Callback invoked  when the use checks a row - item. It will be passed with the arguments: checked(bool),
   * index(number), datum(object), eg: (checked, index, datum) => {}*/
  onDatumSelect: _propTypes.default.func,

  /** Callback invoked when select all input is clicked. It will be invoked with a checked bool property
   * eg: (allSelectedChecked) => {} */
  onSelectAll: _propTypes.default.func,

  /** Array of SelectInput options */
  pageSizeOptions: _propTypes.default.array,

  /** Callback fired when the user selects a page size. Similar with the onChange callback of the SelectInput
   * component*/
  onPageSizeChange: _propTypes.default.func,

  /** Callback fired when the user selects an action. Similar with the onChange callback of the SelectInput
   * component*/
  onSelectAction: _propTypes.default.func,

  /** Selected key from options. Similar with the SelectInput component */
  selectedAction: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Callback invoked when the user triggers an action */
  onSelectedActionApply: _propTypes.default.func,

  /** The total records */
  totalRecords: _propTypes.default.number,

  /** String that must match the sortable column id property. MUST be specified IF column is sortable*/
  orderBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Boolean indicating if the sort order is ascending or descending */
  orderAsc: _propTypes.default.bool,

  /** Boolean indicating if the table should be indented */
  isIndented: _propTypes.default.bool,

  /** Callback invoked on sortable columns click. It will be invoked  with an argument of the column in property.
   * MUST be specified IF column is sortable*/
  onSortedChange: _propTypes.default.func,

  /** Callback invoked with the entire row - datum in order to format the accordion item header as you wish!*/
  accordionItemHeaderFormatter: _propTypes.default.func,

  /** object that describes the expandable row table. You can also add all the properties of The Table component
   * in the property nestedTableProps and they will be passed to the nested component. If you want to map-alter the
   * data before display use the dataFormatter function property. It will be called with the data for display. It
   * MUST return the altered data.*/
  expandableRow: _propTypes.default.shape({
    columns: _propTypes.default.arrayOf(_propTypes.default.shape({
      propertyName: _propTypes.default.string.isRequired,
      header: _propTypes.default.string.isRequired,
      formatter: _propTypes.default.func
    })),
    propertyNameWithData: _propTypes.default.string.isRequired,
    dataFormatter: _propTypes.default.func,
    nestedTableProps: _propTypes.default.object
  }),

  /** Callback invoked to calculate if the row should not be taken into account for selecting.*/
  selectableRowDisabled: _propTypes.default.func,

  /** Changes the header style variant.*/
  headerVariant: _propTypes.default.oneOf(['tertiary']),

  /** Callback invoked  when the user expands a row.
   *  it will be called with the selectedRow and selectedRowIndex passed as args*/
  onExpandRow: _propTypes.default.func,

  /** Callback invoked  when the use  a row  to change the style of row-  */
  onRowStyleChange: _propTypes.default.func,

  /** The header title of the nested table of each row */
  nestedTableTitle: _propTypes.default.string,

  /** flag that indicates if the horizontal rule should be hidden between actions and view select item */
  hideHorizontalRuleOfActions: _propTypes.default.bool,

  /** flag that indicates that the table should have a table-hover style */
  tableHover: _propTypes.default.bool,

  /** flag that indicates that the select action form should not be displayed */
  omitSelectActionForm: _propTypes.default.bool,

  /** flag that indicates that the select action form should be displayed anyway*/
  alwaysDisplaySelectableActionsForm: _propTypes.default.bool,

  /** Custom component to replace the built in nested Table component of each row. It will have the
   * expandable table row passed as a prop */
  customNestedTableComponent: _propTypes.default.element,

  /** Add error message if there are no data */
  noResultsMessage: _propTypes.default.string,

  /** Array of the desired actions. The callback will be invoked when the corresponding action is clicked.
   * The callback function with have the row datum and row index passed as arguments.
   * If a custom component is defined then the actions wil be rendered according to it. The custom component will
   * also have available the props: datum, action & rowIndex */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired,
    customComponent: _propTypes.default.element,
    isActionLink: _propTypes.default.bool
  })),

  /** Test ID for the first page button */
  firstPageTestId: _propTypes.default.string,

  /** Test ID for the previous page button */
  previousPageTestId: _propTypes.default.string,

  /** Test ID for the next page button */
  nextPageTestId: _propTypes.default.string,

  /** Test ID for the last page button */
  lastPageTestId: _propTypes.default.string,

  /** Test ID for the entire pagination wrapper */
  paginationWrapperTestId: _propTypes.default.string,

  /** Test ID for the records shown in the pagination */
  paginationRecordsShownTestId: _propTypes.default.string,

  /** Test ID for the view control */
  viewControlTestId: _propTypes.default.string,

  /** String indicating the style to be applied for selected rows */
  selectedRowStyle: _propTypes.default.oneOf([_constants.primaryVariantStyle, _constants.secondaryVariantStyle])
};
var _default = Table;
exports.default = _default;